import script from "./SortContractComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SortContractComponent.vue?vue&type=script&setup=true&lang=js"

import "./SortContractComponent.vue?vue&type=style&index=0&id=1d28b7a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d28b7a4"]])

export default __exports__